import PropTypes from 'prop-types';

export const fieldShape = {
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const formatShape = {
  format: PropTypes.arrayOf(PropTypes.any),
  maxlength: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export const phonePrefixListShape = PropTypes.shape({
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});
